import e, { css } from 'styled-components';

var t=css`
  margin: 0;
  color: ${o=>o.colorToken?`var(--${o.colorToken})`:"var(--foreground-primary)"};
  font-size: var(--font-size-large);
  font-weight: var(--font-weight-semibold);
  line-height: var(--line-height-small);
`,i=e.h2`
  ${t};
`,n=i;

export { t as a, n as b };
